import { mainSiteUrl } from "@/mocks/categories";
import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20modern%20fashion%20merchandise%20flat%20lay%20product%20photography%20with%20diverse%20clothing%20items%20including%20sneakers%20hoodies%20caps%20and%20accessories%20arranged%20harmoniously%20on%20warm%20cream%20surface%2C%20soft%20natural%20daylight%2C%20minimalist%20editorial%20composition%2C%20clean%20airy%20atmosphere%2C%20professional%20ecommerce%20aesthetic%2C%20warm%20coral%20and%20beige%20color%20scheme%2C%20high%20detail%2C%20luxurious%20yet%20approachable%20look&width=1600&height=900&seq=hero-usfans-merch-2026&orientation=landscape"
          alt="USFans Spreadsheet - baza twórców i narzędzia analityczne"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-semibold text-white leading-tight mb-6">
            USFans Spreadsheet — Największa baza twórców i narzędzi dla agencji
          </h1>
          <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto mb-10 leading-relaxed">
            Odkryj twórców, analizuj profile i rozwijaj swoją agencję szybciej dzięki USFans Spreadsheet. Kompletny przewodnik 2026.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={`${mainSiteUrl}`}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto inline-flex items-center justify-center px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap shadow-lg shadow-primary-500/25"
            >
              <i className="ri-database-2-line mr-2 text-lg"></i>
              USFans Spreadsheet
            </a>
            <a
              href={`${mainSiteUrl}`}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto inline-flex items-center justify-center px-8 py-3.5 rounded-full bg-white/95 text-foreground-900 text-base font-semibold hover:bg-white transition-all duration-200 whitespace-nowrap"
            >
              <i className="ri-shopping-bag-3-line mr-2 text-lg"></i>
              Kup Teraz
            </a>
            <Link
              to="/artykul/usfans-spreadsheet-kompletny-przewodnik-2026"
              className="w-full sm:w-auto inline-flex items-center justify-center px-8 py-3.5 rounded-full border-2 border-white/60 text-white text-base font-medium hover:bg-white/10 transition-all duration-200 whitespace-nowrap"
            >
              <i className="ri-book-open-line mr-2 text-lg"></i>
              Przeczytaj poradnik
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}